// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8di0O","content":"styles_content__2yKgA"};